import React from 'react';
import { LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import { formatDate } from '../../Utils/utils';

const TransfersChart = ({ data }) => {
  if (!data || !Array.isArray(data) || data.length === 0) {
    return (
      <div style={{ textAlign: 'center', marginBottom: '20px' }}>
        <h5>Transferências da última semana</h5>
        <p>Sem dados disponíveis.</p>
      </div>
    );
  }

  const formattedData = data.map(item => ({
    date: formatDate(item.data), 
    product: item.product?.name || '',
    quantity: Number(item.product?.quantity) || 0
  }));

  const groupedData = formattedData.reduce((acc, item) => {
    if (!acc[item.product]) acc[item.product] = {};
    acc[item.product][item.date] = item.quantity;
    return acc;
  }, {});

  const categories = [...new Set(formattedData.map(item => item.date))];

  const chartData = categories.map(date => {
    const entry = { data: date };
    Object.keys(groupedData).forEach(product => {
      entry[product] = groupedData[product][date] || 0;
    });
    return entry;
  });

  const colors = ['#0088FE', '#00C49F', '#FFBB28', '#FF8042', '#8884d8', '#82ca9d'];

  return (
    <div style={{ textAlign: 'center', marginBottom: '20px' }}>
      <h5>Transferências da última semana</h5>
      <ResponsiveContainer width="100%" height={350}>
        <LineChart data={chartData}>
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="data" />
          <YAxis />
          <Tooltip formatter={(value) => `${Number(value).toFixed(0)} Kg`} />
          <Legend />
          {Object.keys(groupedData).map((product, index) => (
            <Line
              key={product}
              type="monotone"
              dataKey={product}
              stroke={colors[index % colors.length]}
              strokeWidth={2}
            />
          ))}
        </LineChart>
      </ResponsiveContainer>
    </div>
  );
};

export default TransfersChart;
